import React, { useState, useEffect } from "react";
import "../Styles/Header.css";
import { FaBehance, FaLinkedin, FaGithub, FaBars } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import Logo from "../Assets/Disena Logo White.png";

const sectionIds = ["heroSection", "about", "logos", "case-studies", "contact"];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("heroSection");

  const handleMenuToggle = () => setMenuOpen((prev) => !prev);
  const handleLinkClick = () => setMenuOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      let current = "heroSection";
      for (const id of sectionIds) {
        const section = document.getElementById(id);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 80 && rect.bottom >= 80) {
            current = id;
          }
        }
      }
      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="header-container">
      <div className="logo">
        <img src={Logo} alt="Disena Logo" style={{ width: "100px" }} />
      </div>
      <button
        className="menu-toggle"
        onClick={handleMenuToggle}
        aria-label="Toggle navigation menu"
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>
      <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
        <ul>
          <li>
            <a
              href="#heroSection"
              onClick={handleLinkClick}
              className={activeSection === "heroSection" ? "active-link" : ""}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#about"
              onClick={handleLinkClick}
              className={activeSection === "about" ? "active-link" : ""}
            >
              About Me
            </a>
          </li>
          <li>
            <a
              href="#logos"
              onClick={handleLinkClick}
              className={activeSection === "logos" ? "active-link" : ""}
            >
              Logos
            </a>
          </li>
          <li>
            <a
              href="#case-studies"
              onClick={handleLinkClick}
              className={activeSection === "case-studies" ? "active-link" : ""}
            >
              Case Studies
            </a>
          </li>
          <li>
            <a
              href="#contact"
              onClick={handleLinkClick}
              className={activeSection === "contact" ? "active-link" : ""}
            >
              Let's Create
            </a>
          </li>
        </ul>
        <div className="social-icons">
          <a
            href="https://www.instagram.com/gbengdesigns/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaBehance />
          </a>
          <a
            href="https://www.linkedin.com/in/gbengdesigns/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/gbengdesigns"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub />
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;
